import { Dialog } from "@headlessui/react";

interface CancelLabelModalProps {
  isOpen: boolean;
  carrier: string;
  trackingNumber: string;
  cost: number;
  onClose: () => void;
}

const CancelLabelModal = ({
  isOpen,
  carrier,
  trackingNumber,
  cost,
  onClose,
}: CancelLabelModalProps) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div
        className="fixed inset-0 bg-black/45 backdrop-blur-sm"
        aria-hidden="true"
      />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-150 rounded-2xl bg-white md:p-8 p-5 shadow-xl text-center">
          <Dialog.Title className="md:text-2xl text-xl font-semibold text-gray-950">
            Cancel Shipping Label?
          </Dialog.Title>

          <p className="mt-3 text-sm md:text-base font-normal text-gray-500">
            Are you sure you want to cancel this shipping label? The label will
            no longer be valid and a refund will be requested.
          </p>

          <div className="mt-8 flex flex-col gap-2.5 rounded-xl bg-[#F9FAFB] p-4 text-left text-sm md:text-base text-gray-500">
            <span>{carrier}</span>
            <span className="break-all">Tracking ID: {trackingNumber}</span>
            <span>Label cost: ${cost.toFixed(2)}</span>
          </div>

          <div className="mt-8 flex md:gap-5 gap-3">
            <button
              type="button"
              onClick={onClose}
              className="h-13 w-full rounded-xl text-base font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors"
            >
              Keep Label
            </button>
            <button
              type="button"
              className="h-13 w-full rounded-xl text-base font-medium text-white bg-red-500 hover:bg-red-600 disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer transition-colors"
            >
              Cancel Label
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default CancelLabelModal;
